import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'Ho già provato altre cose e non hanno funzionato. Perché questo sarebbe diverso?',
    a: "Ciò che hai provato prima probabilmente attaccava il sintomo — il comportamento — senza toccare la struttura emotiva che lo mantiene attivo. Il Ciclo P-C-V lavora sul meccanismo reale: il circolo neuroemotivo. È questo che fa la differenza."
  }, {
    q: 'Quanto tempo al giorno mi serve?',
    a: 'Le pratiche sono pensate per 5-15 minuti al giorno. Non richiedono attrezzature, spazi particolari, né che qualcun altro lo sappia. Se hai tempo per il ciclo, hai tempo per interromperlo.'
  }, {
    q: 'Questo sostituisce la terapia?',
    a: 'Non sostituisce la terapia — la completa. Ma funziona in modo indipendente per chi non ha accesso alla terapia in questo momento, o preferisce lavorare sul proprio percorso in privato. Nota: se sei in una situazione di crisi, rivolgiti prima a un professionista.'
  }, {
    q: 'E se ricado durante i 21 giorni?',
    a: 'Il sistema lo prevede. Non è una promessa di perfezione — è un processo di riorientamento progressivo. Una ricaduta durante il percorso non cancella il lavoro fatto. È informazione, non fallimento.'
  }, {
    q: 'Funziona per qualsiasi tipo di dipendenza o compulsione?',
    a: 'Se riconosci il Ciclo P-C-V nella tua esperienza — indipendentemente dal comportamento specifico — il sistema è pensato per te. Il meccanismo emotivo è lo stesso nella maggior parte delle dipendenze e compulsioni.'
  }, {
    q: 'In quale formato arriva il materiale completo?',
    a: 'Tutto il materiale arriva in formato digitale PDF. Lo ricevi via email immediatamente dopo l\'acquisto — senza attese.'
  }];
  return <section className="py-6 md:py-9 px-5 bg-[radial-gradient(ellipse_at_left,rgba(107,0,182,0.1)_0%,transparent_60%),var(--dark-bg)]" data-id="element-25" data-mp="3udja3oepu87s">
      <div className="max-w-[900px] mx-auto" data-id="element-26" data-mp="1ybfzktvaz8ne">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-27" data-mp="23993fg94vqki">
          Domande frequenti
        </span>
        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-28" data-mp="2c8mgeiwgux9z">
          Quello che forse
          <br data-id="element-29" data-mp="2h6xq8tmrh7s7" />
          <span className="text-gradient-magenta" data-id="element-30" data-mp="2h7fsq800oi8k">ti stai chiedendo</span>
        </h2>
        <div className="mt-4 space-y-2" data-id="element-31" data-mp="2m60l5l911xmg">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={`bg-[rgba(107,0,182,0.08)] border rounded-[14px] overflow-hidden transition-colors duration-200 ease-out ${isOpen ? 'border-[rgba(194,0,111,0.4)]' : 'border-[rgba(107,0,182,0.25)] hover:border-[rgba(194,0,111,0.4)]'}`} data-id="element-32" data-mp="2r04to8xxydpn" data-mpi={idx}>
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} aria-expanded={isOpen} className="w-full bg-transparent border-none text-white font-heading font-bold text-[0.95rem] text-left py-3.5 px-5 cursor-pointer flex justify-between items-center gap-4" data-id="element-33" data-mp="ta6mxdrvjc10">
                  {faq.q}
                  <span className={`text-magenta-bright text-[1.4rem] shrink-0 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : 'rotate-0'}`} data-id="element-34" data-mp="fc9mu7e7onhl">
                    +
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-35" data-mp="137cfkqg4zb3c">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-36" data-mp="ya2pr9ou4xez">
                      <div className="px-5 pb-3.5 text-[0.92rem] leading-[1.6] text-white/75" data-id="element-37" data-mp="1akse3xvr34c1">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}